document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('[data-hero-slider]');
  if (!hero) return;

  const slidesContainer = hero.querySelector('[data-hero-slides]');
  let slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
  const prevBtn = hero.querySelector('[data-hero-prev]');
  const nextBtn = hero.querySelector('[data-hero-next]');
  const dotsContainer = hero.querySelector('[data-hero-dots]');

  if (!slidesContainer || slides.length === 0) return;

  // Mischia casualmente le slide caricate
  slides = slides
    .map(slide => ({ slide, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(item => item.slide);

  slides.forEach(slide => slidesContainer.appendChild(slide));

  let currentIndex = 0;
  let autoplay = null;

  if (dotsContainer && slides.length > 1) {
    dotsContainer.innerHTML = '';

    slides.forEach(function (_, index) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'w-2.5 h-2.5 rounded-full bg-white/40 hover:bg-gold transition-colors';
      dot.setAttribute('aria-label', 'Vai alla slide ' + (index + 1));

      dot.addEventListener('click', function () {
        showSlide(index);
        restartAutoplay();
      });

      dotsContainer.appendChild(dot);
    });
  }

  const dots = dotsContainer ? Array.from(dotsContainer.children) : [];

  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    slides.forEach(function (slide, i) {
      slide.style.opacity = i === index ? '1' : '0';
      slide.style.pointerEvents = i === index ? 'auto' : 'none';
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    dots.forEach(function (dot, i) {
      dot.classList.toggle('bg-gold', i === index);
      dot.classList.toggle('bg-white/40', i !== index);
    });

    currentIndex = index;
  }

  function nextSlide() {
    showSlide(currentIndex + 1);
  }

  function prevSlide() {
    showSlide(currentIndex - 1);
  }

  function startAutoplay() {
    if (slides.length <= 1) return;
    autoplay = setInterval(nextSlide, 5000);
  }

  function restartAutoplay() {
    if (autoplay) clearInterval(autoplay);
    startAutoplay();
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      nextSlide();
      restartAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prevSlide();
      restartAutoplay();
    });
  }

  let touchStartX = 0;

  hero.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  });

  hero.addEventListener('touchend', function (e) {
    const touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }

      restartAutoplay();
    }
  });

  showSlide(0);
  startAutoplay();
});